import React from 'react';

interface StreamControlsProps {
  onStart: () => Promise<void>;
  onStop: () => void;
  isStreaming: boolean; // Represents if *any* track (intro signal or live media) is active
  isOwner: boolean;
  isMicMuted: boolean;
  isCamOff: boolean;
  isSharingScreen: boolean;
  onToggleMic: () => void;
  onToggleCam: () => void;
  onStartScreenShare: () => Promise<void>;
  onStopScreenShare: () => Promise<void>;
  disableMediaControls?: boolean; // New prop to disable mic/cam/share during intro
}

const StreamControls: React.FC<StreamControlsProps> = ({
  onStart,
  onStop,
  isStreaming,
  isOwner,
  isMicMuted,
  isCamOff,
  isSharingScreen,
  onToggleMic,
  onToggleCam,
  onStartScreenShare,
  onStopScreenShare,
  disableMediaControls = false, // Default to false
}) => {
  const handleScreenShareToggle = () => {
    if (isSharingScreen) {
      onStopScreenShare();
    } else {
      onStartScreenShare();
    }
  };

  // isLive ahora representa si hay actividad de stream (intro o live)
  const isLive = isStreaming;

  return (
    <div className="flex flex-wrap gap-2 mb-4"> {/* flex-wrap para mejor responsividad */}
      {/* Start/Stop Stream */}
      <button
        onClick={onStart}
        disabled={isLive} // Disable Start if intro or live stream is active
        className={`p-2 rounded-[10px] text-white flex-grow ${
          isLive
            ? 'bg-gray-500 cursor-not-allowed'
            : 'bg-gradient-to-r from-[#1c5290] to-[#45c0be] hover:opacity-90'
        }`}
      >
        Start Stream
      </button>
      <button
        onClick={onStop}
        disabled={!isLive} // Enable Stop if intro or live stream is active
        className={`p-2 rounded-[10px] text-white flex-grow ${
          !isLive ? 'bg-gray-500 cursor-not-allowed' : 'bg-red-600 hover:bg-red-700'
        }`}
      >
        Stop Stream
      </button>

      {/* Mic/Cam Controls (Show if live, disable if intro phase or sharing screen) */}
      {isLive && (
        <>
          <button
            onClick={onToggleMic}
            disabled={disableMediaControls} // Disable during intro
            className={`p-2 rounded-[10px] text-white flex-grow ${
              disableMediaControls ? 'bg-gray-500 cursor-not-allowed' :
              isMicMuted ? 'bg-yellow-600 hover:bg-yellow-700' : 'bg-blue-600 hover:bg-blue-700'
            }`}
            title={disableMediaControls ? "Controls disabled during intro" : ""}
          >
            {isMicMuted ? 'Unmute Mic' : 'Mute Mic'}
          </button>
          <button
            onClick={onToggleCam}
            disabled={isSharingScreen || disableMediaControls} // Disable if sharing OR during intro
            className={`p-2 rounded-[10px] text-white flex-grow ${
              isSharingScreen || disableMediaControls ? 'bg-gray-500 cursor-not-allowed' :
              isCamOff ? 'bg-yellow-600 hover:bg-yellow-700' : 'bg-blue-600 hover:bg-blue-700'
            }`}
            title={isSharingScreen ? "Stop screen share to enable camera" : disableMediaControls ? "Controls disabled during intro" : ""}
          >
            {isCamOff ? 'Start Cam' : 'Stop Cam'}
          </button>
        </>
      )}

       {/* Screen Share Toggle (Show if live, disable during intro) 
       {isLive && (
           <button
               onClick={handleScreenShareToggle}
               disabled={disableMediaControls} // Disable during intro
               className={`p-2 rounded-[10px] text-white flex-grow ${
                   disableMediaControls ? 'bg-gray-500 cursor-not-allowed' :
                   isSharingScreen ? 'bg-red-600 hover:bg-red-700' : 'bg-green-600 hover:bg-green-700'
               }`}
               title={disableMediaControls ? "Controls disabled during intro" : ""}
           >
               {isSharingScreen ? 'Stop Sharing' : 'Share Screen'}
           </button>
       )}
           */}
    </div>
  );
};

export default StreamControls;
